import { resetStore } from '@/redux/actions/resetStore'
import auth from '@/redux/reducers/auth'
import licence from '@/redux/reducers/licence'
import orders from '@/redux/reducers/orders'
import printers from '@/redux/reducers/printers'
import screen from '@/redux/reducers/screen'
import { Action, combineReducers } from '@reduxjs/toolkit'

const combinedReducer = combineReducers({
    auth,
    licence,
    orders,
    screen,
    printers,
})

type RootState = ReturnType<typeof combinedReducer>

const rootReducer = (state: RootState | undefined, action: Action): RootState => {
    if (action.type === resetStore.type) {
        state = undefined
    }

    return combinedReducer(state, action)
}

export default rootReducer
